import { Button } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { buttonStyling } from './Actions.styles';
import { useEventTracking } from '../Tracking/useEventTracking';

export interface BasketEditActionProps {
  mode: 'basket';
  onClick?: () => void;
}

export interface WishlistEditActionProps {
  mode: 'wishlist';
  onClick?: () => void;
}

export type EditActionProps = BasketEditActionProps | WishlistEditActionProps;

const message = defineMessage({
  id: 'EditAction.ButtonText',
  defaultMessage: 'Ändern',
  description: 'this will be displayed on the button',
});

export const EditAction: React.FC<EditActionProps> = ({ onClick }) => {
  const { formatMessage } = useIntl();
  const dispatch = useEventTracking();

  const onClickHandler = () => {
    // display cart is fired from basket component due to its rerendering
    dispatch('basket_article', 'change');
    onClick?.();
  };

  return (
    <Button
      sx={buttonStyling}
      onClick={() => onClickHandler()}
      data-testid="edit-action"
      variant="text"
      startIcon={<div className="icon-emp-edit size-3" />}
    >
      {formatMessage(message)}
    </Button>
  );
};
